// import ElementUI from 'element-ui'
import { Loading } from 'element-ui'
import { Toast, Dialog } from 'vant'

/**
 * 封装提示框
 */

let loadingInstance

export default {
  // message(type, message, duration, showClose) {
  //   type = type || 'info'
  //   duration = duration || 1000
  //   showClose = showClose || false
  //   ElementUI.Message({
  //     type: type, // 类型
  //     message: message, // 内容
  //     duration: duration, // 时间
  //     showClose: showClose, // 是否显示关闭按钮
  //   })
  // },
  toast(message, type, duration) {
    type = type || 'text'
    duration = duration || 1000
    Toast({
      type: type, // 类型
      message: message, // 内容
      duration: duration, // 时间
    })
  },
  dialog(title, message) {
    title = title || ''
    message = message || ''
    Dialog.confirm({
      title: title,
      message: message,
    })
      .then(() => {
        // on confirm
        console.log('confirm')
      })
      .catch(() => {
        // on cancel
        console.log('cancel')
      })
  },
  // 打开遮罩层
  loading(content) {
    console.log('loading', content)
    loadingInstance = Loading.service({
      lock: true,
      text: content,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
  },
  // 关闭遮罩层
  closeLoading() {
    loadingInstance.close()
  },
}
